'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.set = set;
exports.clear = clear;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'topDestinations/SET';
var CLEAR = 'topDestinations/CLEAR';

var initialState = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return [].concat((0, _toConsumableArray3.default)(action.topDestinations.items));
    case CLEAR:
      return [].concat(initialState);
    default:
      return state;
  }
}

function set(topDestinations) {
  return {
    type: SET,
    topDestinations: topDestinations
  };
}

function clear() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/topDestinations.js
// module id = 286
// module chunks = 0